import React from 'react'
import styled from 'styled-components'
import OrderlikeLayout from '../../../../../generic/Layouts/OrderlikeLayout'
import FancyButton from '../../knisotLines/Components/FancyButton'
import QuotationTitleCard from './QuotationTitleCard'
import QuotationInitModal from './QuotationInitModal'
import QuotationDetailsTable from './QuotationDetailsTable'
import useOrderQuotationDetails from '../service/useOrderQuotationDetails'

const OrderQuotationDetails: React.FC = () => {
  const {
    isInitModalOpen,
    isLoading,
    titleData,
    details,
    customerList,
    customerID,
    setCustomerID,
    selectedDate,
    setSelectedDate,
    handleConfirmCreate,
    handlePriceChange,
    handleChangeStatus,
    handleGoBack,
  } = useOrderQuotationDetails()

  return (
    <OrderlikeLayout label="פרטי הצעת מחיר">
      {isInitModalOpen && (
        <QuotationInitModal
          customerList={customerList}
          customerID={customerID}
          setCustomerID={setCustomerID}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          onConfirm={handleConfirmCreate}
          onClose={handleGoBack}
          isLoading={isLoading}
        />
      )}

      {titleData && (
        <QuotationTitleCard
          item={titleData}
        />
      )}

      {details.length > 0 && (
        <QuotationDetailsTable
          details={details}
          onPriceChange={handlePriceChange}
        />
      )}

      {isLoading && !isInitModalOpen && <LoadingText>טוען...</LoadingText>}

      <ButtonWrapper>
        <FancyButton onClick={handleGoBack}>סיום</FancyButton>
      </ButtonWrapper>
    </OrderlikeLayout>
  )
}

export default OrderQuotationDetails

const LoadingText = styled.p`
  text-align: center;
  color: #297f76;
  font-weight: 600;
  padding: 2em 0;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 1em 0;
  margin-top: auto;
`
